import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import api from "../../../api/api";
import apiUtil from "../../../api/apiUtil";
import CustomButton from "../../../components/CustomButton/custombutton";
import FAQItem from "../../../components/FAQItem/faqItem";
import add from "../../../images/icons/add.png";
import getToken from "../../getToken";
import "./faq.css";
import * as Yup from "yup";
import CustomInput from "../../../components/CustomInput/CustomInput";
import TextEditor from "../../../components/TextEditor/textEditor";

const FAQ = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [faqList, setFaqList] = useState([]);
  const [showAddFAQ, setShowAddFAQ] = useState(false);
  const [showEditFAQ, setShowEditFAQ] = useState(false);
  const [editDetail, setEditDetail] = useState({
    question: "",
    answer: "",
  });

  const changeActiveTabHandler = (newTab) => {
    setActiveTab(newTab);
    clickBtnClose();
    setFaqList([]);
    retrieveFAQList(newTab);
  };
  let brandId = localStorage.getItem("brandId");
  const retrieveFAQList = (activeTab) => {
    debugger;

    const param = {
      keyword: "",
      rowLimit: 10,
      currentPage: 1,
      brandId: brandId,
      type: activeTab,
      sortBy: "createdDate",
    };

    api.post("Admin/GetFAQListByType", param, getToken()).then((result) =>
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
            
          } else if (response.data.code == 200){
            setFaqList( response.data.data && response.data.data.length > 0
              ? response.data.data
              : []);
          }else {
            setFaqList([]);
          }
        },
        (error) => {
          console.log(error);
        }
      )
    );
  };

  const clickBtnClose = () => {
    setShowAddFAQ(false);
    setShowEditFAQ(false);
  };

  const clickAddFQA = () => {
    setEditDetail({ question: "", answer: "" });
    setShowAddFAQ(true);
  };

  const AddFAQFormValidation = Yup.object().shape({
    question: Yup.string().required("Please enter the question."),
    answer: Yup.string().required("Please enter the answer"),
  });

  const onSubmitFAQHandler = (values, actions) => {
    const paramFAQ = {
      brandId: brandId,
      type: activeTab,
      question: values.question,
      answer: values.answer,
    };

    api.post("Admin/CreateFAQ", paramFAQ, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {

          if (response.data.code === 200) {
            alert("FAQ saved successfully!!");
            console.log(response.data);

            // reset the inputs and clear values
            actions.resetForm();
            values = {};
            setShowAddFAQ(false);

            // refresh faq list
            retrieveFAQList(activeTab);
          } else if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else {
            alert(response.data.message);
          }
        },
        (error, type) => {
          alert(error);
          values = {};
        }
      );
    });
    actions.setSubmitting(false);
  };

  const onSubmitFAQEditHandler = (values, actions) => {
    console.log(values);
    const paramFAQ = {
      id: values.id,
      brandId: values.brandId,
      type: 0,
      question: values.question,
      answer: values.answer,
    };

    api.post("Admin/UpdateFAQByAdmin", paramFAQ, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          console.log(response.data);

          if (response.data.statusCode === 200) {
            alert("FAQ edited successfully!!");
            console.log(response.data.statusCode)

            // reset the inputs and clear values
            actions.resetForm();
            values = {};
            setShowEditFAQ(false);

            // refresh faq list
            retrieveFAQList(activeTab);
          } else if (response.data.statusCode === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else {
            alert(response.data.message);
          }
        },
        (error, type) => {
          alert(error);
          values = {};
        }
      );
    });
    actions.setSubmitting(false);
  };

  console.log(editDetail);
  useEffect(() => {
    retrieveFAQList(activeTab);
  }, []);
  
  return (
    <div className="faq">
      <h4 className="title_text mt-2">FAQ</h4>
      <div className="menuBtnList">
        <CustomButton
          text="Sedona Loyalty"
          addIcon={false}
          className={`btnMenu ${activeTab === 1 ? "active" : ""}`}
          onClick={() => changeActiveTabHandler(1)}
        />
        <CustomButton
          text="My Account"
          addIcon={false}
          className={`btnMenu ${activeTab === 2 ? "active" : ""}`}
          onClick={() => changeActiveTabHandler(2)}
        />
        <CustomButton
          text="Rewards"
          addIcon={false}
          className={`btnMenu ${activeTab === 3 ? "active" : ""}`}
          onClick={() => changeActiveTabHandler(3)}
        />
        <CustomButton
          text="Membership"
          addIcon={false}
          className={`btnMenu ${activeTab === 4 ? "active" : ""}`}
          onClick={() => changeActiveTabHandler(4)}
        />
        <CustomButton
          text="Tier Benefits"
          addIcon={false}
          className={`btnMenu ${activeTab === 5 ? "active" : ""}`}
          onClick={() => changeActiveTabHandler(5)}
        />
      </div>

      <div className=" faqList-container">
        {showAddFAQ || showEditFAQ ? (
          // FAQ Form
       
            <Formik
              initialValues={
                showEditFAQ
                  ? editDetail
                  : {
                      question: "",
                      answer: "",
                    }
              }
              validateOnBlur={false}
              validationSchema={AddFAQFormValidation}
              onSubmit={(values, actions) => {
                showAddFAQ
                  ? onSubmitFAQHandler(values, actions)
                  : onSubmitFAQEditHandler(values, actions);
              }}
            >
              {({ values, errors, touched, handleBlur, setFieldValue }) => (
                <Form className="row faq-form">
                  <div className="col-12 mt-2">
                    <CustomInput
                      label="Input Question"
                      type="text"
                      name="question"
                      hideicon="true"
                      customclass="input_wrapper"
                      placeholder="Enter question"
                    />
                  </div>

                  <div className="col-12 mt-2">
                    <TextEditor
                      label="Input Answer"
                      type="text"
                      name="answer"
                      placeholder="Answer"
                      customclass="input_wrapper"
                      initialValues={editDetail}
                      onChange={(htmlContent) => setFieldValue("answer", htmlContent)}
                    />
                  </div>

                  <div className="col-12 mt-3">
                    <div className="Actions justify-content-end">
                      <button
                        type="button"
                        className="button btnCancel"
                        onClick={clickBtnClose}
                      >
                        Cancel
                      </button>
                      <button type="submit" className="button btnSave">
                        Save
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>

        ) : (
          // FAQ List
          <>
            <CustomButton
              icon={add}
              text="Add"
              addIcon={true}
              className="btnAdd"
              onClick={clickAddFQA}
            />

            {faqList.map((faqItem) => (
              <FAQItem
                key={faqItem.id}
                {...faqItem}
                setShowEditFAQ={setShowEditFAQ}
                setEditDetail={setEditDetail}
              />
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default FAQ;
